import React from 'react';
import { AppRouteInfo, AppRouteKeys } from '../../routes/AppRoutes';
import { useHistory } from 'react-router-dom';

    interface ISessionLinkProps {
        checked: boolean,
        sessionNumber: number,
        planCode: string,
        version: string,
        currentSessionRef: React.RefObject<HTMLDivElement> | null,
        scheduledSessionIndexed: boolean,
        prevHighlightedIndexed: boolean,
        acceleratedPace: boolean,
        updateSessionCompletion: (checked: boolean, index: number) => void
    }
  
const SessionLink: React.FC<ISessionLinkProps> = (props) => {
    const history = useHistory();

    const sessionURL = (sessionNumber: number) => {
        let biblePath = AppRouteInfo[AppRouteKeys.Bible].path;
        biblePath = biblePath.replace(':planCode?', props.planCode);
        biblePath = biblePath.replace(':session?', props.sessionNumber.toString());
        biblePath = biblePath.replace(':version?', props.version);
        return biblePath;
      }

    return (

        <div
            ref={props.currentSessionRef}
            className={ 
                props.scheduledSessionIndexed ? 'highlighted-session-row' :
                props.prevHighlightedIndexed ? 'session-row-no-boarder' : 
                'session-row'
            }
        >
            <div className="day-name-col">
                <span id={`session-${props.sessionNumber}`}
                onClick={()=> history.push(sessionURL(props.sessionNumber))}
                className="session-text">{props.acceleratedPace ? 'READING' : 'DAY'} {props.sessionNumber}</span>
            </div>
            <div className="checkbox-col">
                <span className="browse-checkbox-icon" 
                onClick={() => {props.updateSessionCompletion(props.checked, props.sessionNumber - 1)}}>
                    <i className={props.checked ? "icon-ok-squared" : "icon-blank"} />
                </span>
            </div>
        </div>

    );
};
  
export default SessionLink;